import React, { useContext, useEffect, useState } from "react";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Modal from "../../components/Genericos/Modal/Modal";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import SugerenciaCmp from "../../components/Genericos/Sugerencias/SugerenciaCmp";
import { PortalContext } from "../../context/Provider";
import { displayAyudaMobile } from "../../../global/utils/ayuda";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { GlobalContext } from "../../../global/context/Provider";
import "./Sugerencias.css";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const Sugerencias = () => {
  const { modalState, ayudaDispatch } = useContext(PortalContext);
  const { toasterState } = useContext(GlobalContext);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;
  
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  useEffect(() => {
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyudaMobile("hidden");
    }, 250);
  }, []);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Sugerencias"} />
      <div className="ptur-bodyContainer-sugerencia">
        <Sidebar />
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"ptur-sugerencia-container"}
        >
          <div className="ptur-sugerencia-titulo">
            <span className="rb24b">Mándanos tus sugerencias</span>
          </div>
          <SugerenciaCmp />
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default Sugerencias;
